import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
}), 'CropPortraitOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropPortraitOutlined.js
// module id = 3026
// module chunks = 2